import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Validators, FormBuilder, FormArray, FormGroup, FormControl } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

import { CommonService } from '../../../common/service/common.service';
import { LimitFlowProposalService } from '../../service/limit-flow-proposal/limit-flow-proposal.service';
import { take } from 'rxjs/operator/take';
import { normalizeDoc } from '../../../cnpj.utils';

@Component({
	selector: 'app-patrimony',
	templateUrl: './patrimony.component.html',
	styleUrls: ['./patrimony.component.scss'],
	providers: [
		CommonService
	]
})
export class PatrimonyComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";
	@Input('proposalGuaranteeID') proposalGuaranteeID: string = "";
	@Input('proposalGuaranteeDocument') proposalGuaranteeDocument: string = "";
	@Input('isProposalGuarantee') isProposalGuarantee: boolean;
	@Input('indice') indice: number;
	@Input('proposalStatus') proposalStatus: string = "";
	@Input('comentarioFiador') comentarioFiador: string = "";
	@Input('currentClientDocument') currentClientDocument: string = "";
	@Input('isUserOwner') isUserOwner: boolean = false;

	@Output('onEditPatrimony') onEditPatrimony: EventEmitter<any> = new EventEmitter();

	patrimonyRural: FormGroup;
	patrimonyUrban: FormGroup;
	patrimonyMachineEquips: FormGroup;
	private token;
	private states: any[] = [];
	private citys: any[] = [];

	public editPatrimonyRuralIndex: number = undefined;
	public editPatrimonyUrbanIndex: number = undefined;
	public editPatrimonyMachineEquipsIndex: number = undefined;
	public ComentarioPatrimonio: string = "";

	public valorHaCultivavelParametro: number = 0;
	private currentCityEditing: string = "";

	constructor(private fb: FormBuilder, private flashMessagesService: FlashMessagesService, private commonService: CommonService, private limitFlowProposalService: LimitFlowProposalService) {
		this.patrimonyRural = fb.group({
			IR: ['', Validators.compose([Validators.required])],
			EstadoID: ['', Validators.compose([Validators.required])],
			CidadeID: ['', Validators.compose([Validators.required])],
			AreaTotalHa: ['', Validators.compose([Validators.required])],
			Benfeitorias: '',
			Onus: ['', Validators.compose([Validators.required])],
		});

		this.patrimonyUrban = fb.group({
			IR: ['', Validators.compose([Validators.required])],
			Descricao: ['', Validators.compose([Validators.required])],
			AreaTotal: ['', Validators.compose([Validators.required])],
			ValorComBenfeitorias: ['', Validators.compose([Validators.required])],
			Onus: ['', Validators.compose([Validators.required])],
			ValorAvaliado: ''
		});

		this.patrimonyMachineEquips = fb.group({
			Descricao: ['', Validators.compose([Validators.required])],
			Ano: ['', Validators.compose([Validators.required])],
			Valor: ['', Validators.compose([Validators.required])]
		});
	}

	ngOnInit() {
		console.log("Open Patrimonys");

		console.log("Patrimonios rurais do cliente na aba patrimonios", this.limitFlowProposalService.ruralsObj);
		console.log("Preços por região do cliente na aba patrimonios", this.limitFlowProposalService.priceByRegionObj);
		console.log("this.currentClientDocument", this.currentClientDocument);
		console.log("this.proposalGuaranteeDocument", this.proposalGuaranteeDocument);

		this.token = localStorage.getItem('yara.token');

		if (!this.isProposalGuarantee) {
			this.ComentarioPatrimonio = $("#comentarioPatrimonio").val().toString();
		} else {
			this.ComentarioPatrimonio = this.comentarioFiador;
			$("#tempComentarioPatrimonialGrupo").val(this.ComentarioPatrimonio);
		}

		$("#tempPotencialPatrimonialIndiceGrupo").val(this.indice);

		this.getState();
	}

	setComentarioPatrimonio(value) {
		if (this.isProposalGuarantee) {
			this.ComentarioPatrimonio = value;
			$("#tempComentarioPatrimonialGrupo").val(this.ComentarioPatrimonio);
		} else {
			this.ComentarioPatrimonio = value;
			$("#comentarioPatrimonio").val(this.ComentarioPatrimonio);
		}
	}

	getMachinesEquipsTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.machinesObj.length; i++) {
			if (this.isProposalGuarantee && this.limitFlowProposalService.machinesObj[i].Documento === this.proposalGuaranteeDocument) {
				sum += this.limitFlowProposalService.machinesObj[i].Valor;
			} else if (!this.isProposalGuarantee && this.limitFlowProposalService.machinesObj[i].Documento === this.currentClientDocument) {
				sum += this.limitFlowProposalService.machinesObj[i].Valor;
			}
		}

		if (!this.proposalGuaranteeDocument && !this.isProposalGuarantee) {
			$("#totalValorMaquinasEquipamentos").val(sum);
		}

		return sum;
	}

	getMachinesEquipsTotals() {

		var porcentagem20 = parseFloat('20');

		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.machinesObj.length; i++) {
			if (this.isProposalGuarantee && this.limitFlowProposalService.machinesObj[i].Documento === this.proposalGuaranteeDocument) {
				sum += this.limitFlowProposalService.machinesObj[i].Valor;
			} else if (!this.isProposalGuarantee && this.limitFlowProposalService.machinesObj[i].Documento === this.currentClientDocument) {
				sum += this.limitFlowProposalService.machinesObj[i].Valor;
			}
		}

		if (!this.proposalGuaranteeDocument && !this.isProposalGuarantee) {
			$("#valorTotalMaquinasEquipamentos").val(Number(sum * (porcentagem20 / 100)).toFixed(2));
		}

		return sum * (porcentagem20 / 100);
	}

	getRuralsAreaTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.ruralsObj.length; i++) {
			if (this.isProposalGuarantee && this.limitFlowProposalService.ruralsObj[i].Documento === this.proposalGuaranteeDocument) {
				sum += this.limitFlowProposalService.ruralsObj[i].AreaTotalHa;
			} else if (!this.isProposalGuarantee && this.limitFlowProposalService.ruralsObj[i].Documento === this.currentClientDocument) {
				sum += this.limitFlowProposalService.ruralsObj[i].AreaTotalHa;
			}
		}

		return sum;
	}

	getRuralsBenfeitoriasTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.ruralsObj.length; i++) {
			if (this.isProposalGuarantee && this.limitFlowProposalService.ruralsObj[i].Documento === this.proposalGuaranteeDocument) {
				sum += this.limitFlowProposalService.ruralsObj[i].Benfeitorias;
			} else if (!this.isProposalGuarantee && this.limitFlowProposalService.ruralsObj[i].Documento === this.currentClientDocument) {
				sum += this.limitFlowProposalService.ruralsObj[i].Benfeitorias;
			}
		}

		return sum;
	}

	getRuralsOnusTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.ruralsObj.length; i++) {
			if (this.isProposalGuarantee && this.limitFlowProposalService.ruralsObj[i].Documento === this.proposalGuaranteeDocument) {
				sum += this.limitFlowProposalService.ruralsObj[i].Onus;
			} else if (!this.isProposalGuarantee && this.limitFlowProposalService.ruralsObj[i].Documento === this.currentClientDocument) {
				sum += this.limitFlowProposalService.ruralsObj[i].Onus;
			}
		}

		return sum;
	}

	getUrbansAreaTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.urbansObj.length; i++) {
			if (this.isProposalGuarantee && this.limitFlowProposalService.urbansObj[i].Documento === this.proposalGuaranteeDocument) {
				sum += this.limitFlowProposalService.urbansObj[i].AreaTotal;
			} else if (!this.isProposalGuarantee && this.limitFlowProposalService.urbansObj[i].Documento === this.currentClientDocument) {
				sum += this.limitFlowProposalService.urbansObj[i].AreaTotal;
			}
		}

		return sum;
	}

	getUrbansBenfeitoriasTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.urbansObj.length; i++) {
			if (this.isProposalGuarantee && this.limitFlowProposalService.urbansObj[i].Documento === this.proposalGuaranteeDocument) {
				sum += this.limitFlowProposalService.urbansObj[i].ValorComBenfeitorias;
			} else if (!this.isProposalGuarantee && this.limitFlowProposalService.urbansObj[i].Documento === this.currentClientDocument) {
				sum += this.limitFlowProposalService.urbansObj[i].ValorComBenfeitorias;
			}
		}

		if (!this.proposalGuaranteeDocument && !this.isProposalGuarantee) {
			$("#valorTotalComBenfeitoriasUrbano").val(Number(sum));
		}

		return sum;
	}

	getUrbansOnusTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.urbansObj.length; i++) {
			if (this.isProposalGuarantee && this.limitFlowProposalService.urbansObj[i].Documento === this.proposalGuaranteeDocument) {
				sum += this.limitFlowProposalService.urbansObj[i].Onus;
			} else if (!this.isProposalGuarantee && this.limitFlowProposalService.urbansObj[i].Documento === this.currentClientDocument) {
				sum += this.limitFlowProposalService.urbansObj[i].Onus;
			}
		}

		return sum;
	}

	getUrbansValorAvaliadoTotal(isPotencial) {

		var porcentagem30 = parseFloat('30');

		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.urbansObj.length; i++) {
			if (this.isProposalGuarantee && this.limitFlowProposalService.urbansObj[i].Documento === this.proposalGuaranteeDocument) {
				sum += this.limitFlowProposalService.urbansObj[i].ValorAvaliado;
			} else if (!this.isProposalGuarantee && this.limitFlowProposalService.urbansObj[i].Documento === this.currentClientDocument) {
				sum += this.limitFlowProposalService.urbansObj[i].ValorAvaliado;
			}
		}

		if (!this.proposalGuaranteeDocument && !this.isProposalGuarantee && !isPotencial) {
			$("#valorTotalBensUrbanos").val(Number(sum * (porcentagem30 / 100)).toFixed(2));
		}

		if (isPotencial) {
			return sum * (porcentagem30 / 100);
		} else {
			return sum;
		}
	}

	maxLengthCheck(e) {
		if (e.target.value.length > e.target.maxLength) {
			e.target.value = e.target.value.slice(0, e.target.maxLength)
		}
	}

	maxDescriptionLength(fieldContent) {
		if (fieldContent.length > 128) {
			this.flashMessagesService.show("A Descrição excedeu o máximo de caracteres permitidos. (max. 128 caracteres)", { cssClass: 'alert-danger', timeout: 6000 });
			return true;
		}

		return false;
	}

	setCidadeEstado(cityID) {
		return this.citys.filter(item => item.ID === cityID);
	}

	getState() {
		this.commonService.getState(this.token).subscribe(result => {
			if (result.Success) {
				this.states = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	getPriceByRegion(cityID, Documento) {
		if (cityID) {
			this.limitFlowProposalService.getPriceByRegion(cityID).subscribe(result => {
				if (result.Success) {
					var price = result.Result ? result.Result : null;

					this.flashMessagesService.show("Bem rural inserido", { cssClass: 'alert-success', timeout: 6000 });

					if (price) {
						var exists = false;
						for (var key in this.limitFlowProposalService.priceByRegionObj) {
							var obj = this.limitFlowProposalService.priceByRegionObj[key];
							if (obj.CidadeID === cityID && ((this.isProposalGuarantee && obj.Documento === this.proposalGuaranteeDocument) ||
								(!this.isProposalGuarantee && obj.Documento === this.currentClientDocument))) {
								exists = true;
							}
						}

						if (!exists) {
							price.ValorHaCultivavelParametro = price.ValorHaCultivavel;
							price.ValorHaNaoCultivavelParametro = price.ValorHaNaoCultivavel;
							price.ModuloRuralParametro = price.ModuloRural;
							price.Documento = normalizeDoc(Documento);
							this.limitFlowProposalService.priceByRegionObj.push(price);
						}

						console.log("Agora", this.limitFlowProposalService.priceByRegionObj);

						this.onEditPatrimony.emit();
					} else {
						this.flashMessagesService.show("Preço por região não disponível para a cidade selecionada.", { cssClass: 'alert-danger', timeout: 6000 });
					}
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			})
		}
	}

	onEditPriceByRegion() {
		console.log("Depois", this.limitFlowProposalService.priceByRegionObj);

		this.flashMessagesService.show("Preço por região alterado.", { cssClass: 'alert-success', timeout: 6000 });

		this.onEditPatrimony.emit();
	}

	getCity(stateID, setCity, index) {
		console.log("stateID", stateID);
		if (stateID) {
			this.commonService.getCity(this.token, stateID).subscribe(result => {
				if (result.Success) {
					this.citys = result.Result;
					if (setCity) {
						//this.setCity(index);
						this.patrimonyRural.patchValue({
							IR: this.limitFlowProposalService.ruralsObj[index].IR,
							EstadoID: this.limitFlowProposalService.ruralsObj[index].EstadoID ? this.limitFlowProposalService.ruralsObj[index].EstadoID : this.limitFlowProposalService.ruralsObj[index].Cidade.EstadoID,
							CidadeID: this.limitFlowProposalService.ruralsObj[index].CidadeID,
							AreaTotalHa: this.limitFlowProposalService.ruralsObj[index].AreaTotalHa,
							Benfeitorias: this.limitFlowProposalService.ruralsObj[index].Benfeitorias,
							Onus: this.limitFlowProposalService.ruralsObj[index].Onus
						});
					}
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			})
		}
	}

	// Rural

	getTotalPatrimonioRural() {
		var porcentagem30 = parseFloat('30');

		let sum = 0;
		for (let i = 0; i < this.limitFlowProposalService.ruralsObj.length; i++) {
			if (this.isProposalGuarantee && this.limitFlowProposalService.ruralsObj[i].Documento === this.proposalGuaranteeDocument) {
				sum += this.getValorAvaliado(this.limitFlowProposalService.ruralsObj[i].Cidade.Nome, i);
			} else if (!this.isProposalGuarantee && this.limitFlowProposalService.ruralsObj[i].Documento === this.currentClientDocument) {
				sum += this.getValorAvaliado(this.limitFlowProposalService.ruralsObj[i].Cidade.Nome, i);
			}
		}

		if (!this.proposalGuaranteeDocument && !this.isProposalGuarantee) {
			$("#valorTotalBensRurais").val(Number(sum * (porcentagem30 / 100)).toFixed(2));
		}

		if (sum) {
			return sum * (porcentagem30 / 100);
		} else {
			return 0;
		}
	}

	getValorHaCultivavel(i) {
		var haCultivavel = this.limitFlowProposalService.ruralsObj[i].AreaTotalHa;
		var porcentagem80 = parseFloat('80');
		return haCultivavel * (porcentagem80 / 100);
	}

	getValorReservaLegal(i) {
		var reservaLegal = this.limitFlowProposalService.ruralsObj[i].AreaTotalHa;
		var porcentagem20 = parseFloat('20');
		return reservaLegal * (porcentagem20 / 100);
	}

	getValorAreaTotal(cidade, i) {
		var valorHaCultivavel = 0;
		var valorHaNaoCultivavel = 0;

		for (let j = 0; j < this.limitFlowProposalService.priceByRegionObj.length; j++) {
			if (this.limitFlowProposalService.priceByRegionObj[j].Cidade && this.limitFlowProposalService.priceByRegionObj[j].Cidade.Nome === cidade) {
				if (this.isProposalGuarantee && this.limitFlowProposalService.priceByRegionObj[j].Documento === this.proposalGuaranteeDocument) {
					valorHaCultivavel = this.limitFlowProposalService.priceByRegionObj[j].ValorHaCultivavel;
					valorHaNaoCultivavel = this.limitFlowProposalService.priceByRegionObj[j].ValorHaNaoCultivavel;
				} else if (!this.isProposalGuarantee && this.limitFlowProposalService.priceByRegionObj[j].Documento === this.currentClientDocument) {
					valorHaCultivavel = this.limitFlowProposalService.priceByRegionObj[j].ValorHaCultivavel;
					valorHaNaoCultivavel = this.limitFlowProposalService.priceByRegionObj[j].ValorHaNaoCultivavel;
				}
			}
		}

		if (valorHaCultivavel > 0 || valorHaNaoCultivavel > 0) {
			return (this.getValorHaCultivavel(i) * valorHaCultivavel) + (this.getValorReservaLegal(i) * valorHaNaoCultivavel);
		} else {
			return 0;
		}
	}

	getValorAreaTotalTotal() {

		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.ruralsObj.length; i++) {
			if (this.isProposalGuarantee && this.limitFlowProposalService.ruralsObj[i].Documento === this.proposalGuaranteeDocument) {
				sum += this.getValorAreaTotal(this.limitFlowProposalService.ruralsObj[i].Cidade.Nome, i);
			} else if (!this.isProposalGuarantee && this.limitFlowProposalService.ruralsObj[i].Documento === this.currentClientDocument) {
				sum += this.getValorAreaTotal(this.limitFlowProposalService.ruralsObj[i].Cidade.Nome, i);
			}
		}

		if (!this.proposalGuaranteeDocument && !this.isProposalGuarantee) {
			$("#totalArealTotalRural").val(Number(sum));
		}

		return sum;

	}

	getValorAreaLivre(i) {
		return this.getValorAreaTotal(this.limitFlowProposalService.ruralsObj[i].Cidade.Nome, i) - this.limitFlowProposalService.ruralsObj[i].Onus;
	}

	getValorAreaLivreTotal() {

		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.ruralsObj.length; i++) {
			if (this.isProposalGuarantee && this.limitFlowProposalService.ruralsObj[i].Documento === this.proposalGuaranteeDocument) {
				sum += this.getValorAreaLivre(i);
			} else if (!this.isProposalGuarantee && this.limitFlowProposalService.ruralsObj[i].Documento === this.currentClientDocument) {
				sum += this.getValorAreaLivre(i);
			}
		}

		return sum;

	}

	getValorAvaliado(cidade, i) {
		var porcentagem70 = parseFloat('70');
		var moduloRural = 0;
		var valorHaCultivavel = 0;

		for (let j = 0; j < this.limitFlowProposalService.priceByRegionObj.length; j++) {
			if (this.limitFlowProposalService.priceByRegionObj[j].Cidade) {
				if (this.limitFlowProposalService.priceByRegionObj[j].Cidade.Nome === cidade) {
					if (this.isProposalGuarantee && this.limitFlowProposalService.priceByRegionObj[j].Documento === this.proposalGuaranteeDocument) {
						moduloRural = this.limitFlowProposalService.priceByRegionObj[j].ModuloRural;
						valorHaCultivavel = this.limitFlowProposalService.priceByRegionObj[j].ValorHaCultivavel;
					} else if (!this.isProposalGuarantee && this.limitFlowProposalService.priceByRegionObj[j].Documento === this.currentClientDocument) {
						moduloRural = this.limitFlowProposalService.priceByRegionObj[j].ModuloRural;
						valorHaCultivavel = this.limitFlowProposalService.priceByRegionObj[j].ValorHaCultivavel;
					}
				}
			}
		}

		//Valor Avaliado (R$) = “Valor da Área Total” + 70% (“Benfeitorias (R$)”) – “Ônus (R$)” – (“Módulo Rural” x “Valor ha Cultivável (R$))”

		//if (moduloRural > 0) {
		moduloRural = moduloRural > 0 ? moduloRural : 0;
		var benfCount = this.limitFlowProposalService.ruralsObj[i].Benfeitorias * (porcentagem70 / 100);
		return ((this.getValorAreaTotal(this.limitFlowProposalService.ruralsObj[i].Cidade.Nome, i) + benfCount) - this.limitFlowProposalService.ruralsObj[i].Onus) - (moduloRural * valorHaCultivavel);
		// } else {
		// 	return 0;
		// }
	}

	getValorAvaliadoTotal() {

		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.ruralsObj.length; i++) {
			if (this.isProposalGuarantee && this.limitFlowProposalService.ruralsObj[i].Documento === this.proposalGuaranteeDocument) {
				sum += this.getValorAvaliado(this.limitFlowProposalService.ruralsObj[i].Cidade.Nome, i);
			} else if (!this.isProposalGuarantee && this.limitFlowProposalService.ruralsObj[i].Documento === this.currentClientDocument) {
				sum += this.getValorAvaliado(this.limitFlowProposalService.ruralsObj[i].Cidade.Nome, i);
			}
		}

		return sum;

	}

	insertPatrimonyRural(rural: any) {
		if (!this.groupAnalysisRules()) {
			this.flashMessagesService.show('Preencha o Grupo na aba Grupo Econômico para poder inserir o bem rural', { cssClass: 'alert-danger', timeout: 6000 });
		}
		else {
			rural.Cidade = this.setCidadeEstado(rural.CidadeID);
			rural.Cidade = rural.Cidade[0];

			if (this.proposalGuaranteeDocument) {
				rural.Documento = this.proposalGuaranteeDocument;
			} else {
				rural.Documento = this.currentClientDocument;
			}
			this.limitFlowProposalService.ruralsObj.push(rural);
			this.patrimonyRural.reset();

			this.getPriceByRegion(rural.CidadeID, rural.Documento);
		}
	}

	removePatrimonyRural(i) {
		var cidade = this.limitFlowProposalService.ruralsObj[i].Cidade.Nome;
		delete this.limitFlowProposalService.ruralsObj[i];
		this.limitFlowProposalService.ruralsObj = this.limitFlowProposalService.ruralsObj.filter(item => item);
		this.flashMessagesService.show("Bem rural removido", { cssClass: 'alert-success', timeout: 6000 });
		this.getValorAreaTotalTotal();
		this.removePriceByRegion(cidade);

		this.onEditPatrimony.emit();
	}

	removePriceByRegion(cidade) {
		for (let i = 0; i < this.limitFlowProposalService.priceByRegionObj.length; i++) {
			if (this.limitFlowProposalService.priceByRegionObj[i].Cidade) {
				if (this.limitFlowProposalService.priceByRegionObj[i].Cidade.Nome === cidade) {
					var exists = false;
					for (let j = 0; j < this.limitFlowProposalService.ruralsObj.length; j++) {
						if ((this.limitFlowProposalService.priceByRegionObj[i].Cidade.Nome === this.limitFlowProposalService.ruralsObj[j].Cidade.Nome) &&
							(this.limitFlowProposalService.priceByRegionObj[i].Documento === this.limitFlowProposalService.ruralsObj[j].Documento)) {
							exists = true;
						}
					}
					if (!exists) {
						delete this.limitFlowProposalService.priceByRegionObj[i];
						this.limitFlowProposalService.priceByRegionObj = this.limitFlowProposalService.priceByRegionObj.filter(item => item);
					}
				}
			}
		}
	}

	editPatrimonyRural(index) {
		this.editPatrimonyRuralIndex = index;
		($(".rurals-list table tbody tr") as any).eq(index).addClass("edit-line");
		($(".rural-form") as any).addClass("editing");
		var stateID = this.limitFlowProposalService.ruralsObj[index].EstadoID ? this.limitFlowProposalService.ruralsObj[index].EstadoID : this.limitFlowProposalService.ruralsObj[index].Cidade.EstadoID;
		this.currentCityEditing = this.limitFlowProposalService.ruralsObj[index].Cidade.Nome;
		this.getCity(stateID, true, index);

		this.onEditPatrimony.emit();
	}

	savePatrimonyRuralEdit() {
		if (this.limitFlowProposalService.ruralsObj[this.editPatrimonyRuralIndex]) {
			this.limitFlowProposalService.ruralsObj[this.editPatrimonyRuralIndex].IR = this.patrimonyRural.controls['IR'].value;
			this.limitFlowProposalService.ruralsObj[this.editPatrimonyRuralIndex].EstadoID = this.patrimonyRural.controls['EstadoID'].value;
			this.limitFlowProposalService.ruralsObj[this.editPatrimonyRuralIndex].CidadeID = this.patrimonyRural.controls['CidadeID'].value;
			var cidade = this.setCidadeEstado(this.patrimonyRural.controls['CidadeID'].value);
			this.limitFlowProposalService.ruralsObj[this.editPatrimonyRuralIndex].Cidade = cidade[0];
			this.limitFlowProposalService.ruralsObj[this.editPatrimonyRuralIndex].AreaTotalHa = this.patrimonyRural.controls['AreaTotalHa'].value;
			this.limitFlowProposalService.ruralsObj[this.editPatrimonyRuralIndex].Benfeitorias = this.patrimonyRural.controls['Benfeitorias'].value;
			this.limitFlowProposalService.ruralsObj[this.editPatrimonyRuralIndex].Onus = this.patrimonyRural.controls['Onus'].value;
			this.removePriceByRegion(this.currentCityEditing);
			this.currentCityEditing = "";
			this.getPriceByRegion(this.limitFlowProposalService.ruralsObj[this.editPatrimonyRuralIndex].CidadeID, this.limitFlowProposalService.ruralsObj[this.editPatrimonyRuralIndex].Documento);
			this.editPatrimonyRuralIndex = undefined;
			this.patrimonyRural.reset();
			($(".rurals-list table tbody tr") as any).removeClass("edit-line");
			($(".rural-form") as any).removeClass("editing");
		}
	}

	cancelPatrimonyRuralEdit() {
		this.editPatrimonyRuralIndex = undefined;
		($(".rurals-list table tbody tr") as any).removeClass("edit-line");
		($(".rural-form") as any).removeClass("editing");
		this.currentCityEditing = "";
		this.patrimonyRural.reset();
	}

	setCity(index) {
		//($('#rural-state option[value='+this.limitFlowProposalService.ruralsObj[index].Estado+']')as any).attr('selected', true);
	}

	groupAnalysisRules() {
		let analiseGrupo = this.limitFlowProposalService.proposalObj['AnaliseGrupo'];
		let grupoEconomicoID = this.limitFlowProposalService.proposalObj['GrupoEconomicoID'];
		
		return (analiseGrupo && grupoEconomicoID != null && grupoEconomicoID != '') || !analiseGrupo;
	}

	// Urbano
	insertPatrimonyUrban(urban: any) {
		if (!this.groupAnalysisRules()) {
			this.flashMessagesService.show('Preencha o Grupo na aba Grupo Econômico para poder inserir o bem urbano', { cssClass: 'alert-danger', timeout: 6000 });
		}
		else if (!this.maxDescriptionLength(urban.Descricao))
		{
			urban.ValorAvaliado = urban.ValorComBenfeitorias - urban.Onus;

			if (this.proposalGuaranteeDocument) {
				urban.Documento = this.proposalGuaranteeDocument;
			} else {
				urban.Documento = this.currentClientDocument;
			}
	
			this.flashMessagesService.show("Bem urbano inserido", { cssClass: 'alert-success', timeout: 6000 });
	
			this.limitFlowProposalService.urbansObj.push(urban);
			this.patrimonyUrban.reset();
	
			this.onEditPatrimony.emit();
		}
	}

	removePatrimonyUrban(urban) {
		this.limitFlowProposalService.urbansObj = this.limitFlowProposalService.urbansObj.filter(item => item !== urban);

		this.flashMessagesService.show("Bem urbano removido", { cssClass: 'alert-success', timeout: 6000 });
		this.getUrbansBenfeitoriasTotal();

		this.onEditPatrimony.emit();
	}

	editPatrimonyUrban(index) {
		this.editPatrimonyUrbanIndex = index;

		this.patrimonyUrban.patchValue({
			IR: this.limitFlowProposalService.urbansObj[index].IR,
			Descricao: this.limitFlowProposalService.urbansObj[index].Descricao,
			AreaTotal: this.limitFlowProposalService.urbansObj[index].AreaTotal,
			ValorComBenfeitorias: this.limitFlowProposalService.urbansObj[index].ValorComBenfeitorias,
			Onus: this.limitFlowProposalService.urbansObj[index].Onus,
			ValorAvaliado: this.limitFlowProposalService.urbansObj[index].ValorAvaliado
		});
		($(".urbans-list table tbody tr") as any).eq(index).addClass("edit-line");
		($(".urban-form") as any).addClass("editing");
		
		this.onEditPatrimony.emit();
	}

	savePatrimonyUrbanEdit(index) {
		if (!this.maxDescriptionLength(this.patrimonyUrban.controls['Descricao'].value))
		{
			this.limitFlowProposalService.urbansObj[this.editPatrimonyUrbanIndex].IR = this.patrimonyUrban.controls['IR'].value;
			this.limitFlowProposalService.urbansObj[this.editPatrimonyUrbanIndex].Descricao = this.patrimonyUrban.controls['Descricao'].value;
			this.limitFlowProposalService.urbansObj[this.editPatrimonyUrbanIndex].AreaTotal = this.patrimonyUrban.controls['AreaTotal'].value;
			this.limitFlowProposalService.urbansObj[this.editPatrimonyUrbanIndex].ValorComBenfeitorias = this.patrimonyUrban.controls['ValorComBenfeitorias'].value;
			this.limitFlowProposalService.urbansObj[this.editPatrimonyUrbanIndex].Onus = this.patrimonyUrban.controls['Onus'].value;
			this.limitFlowProposalService.urbansObj[this.editPatrimonyUrbanIndex].ValorAvaliado = this.patrimonyUrban.controls['ValorComBenfeitorias'].value - this.patrimonyUrban.controls['Onus'].value

			this.editPatrimonyUrbanIndex = undefined;
			this.patrimonyUrban.reset();

			($(".urbans-list table tbody tr") as any).removeClass("edit-line");
			($(".urban-form") as any).removeClass("editing");
	
			this.onEditPatrimony.emit();
		}
	}

	cancelPatrimonyUrbanEdit() {
		this.editPatrimonyUrbanIndex = undefined;

		($(".urbans-list table tbody tr") as any).removeClass("edit-line");
		($(".urban-form") as any).removeClass("editing");

		this.patrimonyUrban.reset();
	}

	// Máquina
	insertPatrimonyMachineEquips(machine: any) {
		if (!this.groupAnalysisRules()) {
			this.flashMessagesService.show('Preencha o Grupo na aba Grupo Econômico para poder inserir o bem máquina/equipamento', { cssClass: 'alert-danger', timeout: 6000 });
		}
		else if (!this.maxDescriptionLength(machine.Descricao))
		{
			if (this.proposalGuaranteeDocument) {
				machine.Documento = this.proposalGuaranteeDocument;
			} else {
				machine.Documento = this.currentClientDocument;
			}
	
			this.flashMessagesService.show("Bem máquinas/equipamentos inserido", { cssClass: 'alert-success', timeout: 6000 });
	
			this.limitFlowProposalService.machinesObj.push(machine);
			this.patrimonyMachineEquips.reset();
	
			this.onEditPatrimony.emit();
		}
	}

	removePatrimonyMachineEquips(machine) {
		this.limitFlowProposalService.machinesObj = this.limitFlowProposalService.machinesObj.filter(item => item !== machine);
		this.flashMessagesService.show("Bem máquinas/equipamentos removido", { cssClass: 'alert-success', timeout: 6000 });
		this.getMachinesEquipsTotal();

		this.onEditPatrimony.emit();
	}

	editPatrimonyMachineEquips(index) {
		this.editPatrimonyMachineEquipsIndex = index;

		this.patrimonyMachineEquips.patchValue({
			Descricao: this.limitFlowProposalService.machinesObj[index].Descricao,
			Ano: this.limitFlowProposalService.machinesObj[index].Ano,
			Valor: this.limitFlowProposalService.machinesObj[index].Valor
		});

		($(".machines-list table tbody tr") as any).eq(index).addClass("edit-line");
		($(".machine-form") as any).addClass("editing");

		this.onEditPatrimony.emit();
	}

	savePatrimonyMachineEquipsEdit(index) {
		if (!this.maxDescriptionLength(this.patrimonyMachineEquips.controls['Descricao'].value))
		{
			this.limitFlowProposalService.machinesObj[this.editPatrimonyMachineEquipsIndex].Descricao = this.patrimonyMachineEquips.controls['Descricao'].value;
			this.limitFlowProposalService.machinesObj[this.editPatrimonyMachineEquipsIndex].Ano = this.patrimonyMachineEquips.controls['Ano'].value;
			this.limitFlowProposalService.machinesObj[this.editPatrimonyMachineEquipsIndex].Valor = this.patrimonyMachineEquips.controls['Valor'].value;
	
			this.editPatrimonyMachineEquipsIndex = undefined;
			this.patrimonyMachineEquips.reset();
	
			($(".machines-list table tbody tr") as any).removeClass("edit-line");
			($(".machine-form") as any).removeClass("editing");
	
			this.onEditPatrimony.emit();
		}
	}

	cancelPatrimonyMachineEquipsEdit() {
		this.editPatrimonyMachineEquipsIndex = undefined;
		($(".machines-list table tbody tr") as any).removeClass("edit-line");
		($(".machine-form") as any).removeClass("editing");
		this.patrimonyMachineEquips.reset();
	}

	getFullPatrimonioTotal() {
		if (!this.proposalGuaranteeDocument && !this.isProposalGuarantee) {
			this.limitFlowProposalService.proposalObj['PotencialPatrimonial'] = Number((this.getTotalPatrimonioRural() + this.getUrbansValorAvaliadoTotal(true) + this.getMachinesEquipsTotals()).toFixed(2));
		}
		return this.getTotalPatrimonioRural() + this.getUrbansValorAvaliadoTotal(true) + this.getMachinesEquipsTotals();
	}
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/patrimony/patrimony.component.ts